import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WindowCloseComponent } from './window-close/window-close.component';

const routes: Routes = [{ path: 'windowclose', component: WindowCloseComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpersRoutingModule {}
